export default function ({ $axios, store }) {
    $axios.onError(err => {
        const code = parseInt(err.response && err.response.status)
        if (code === 401)
            store.dispatch('errors/addError', ({ code: 401 }))
        else
            store.dispatch('errors/addError', ({ code: 'axios-generic' }))
    })
}
